import { render } from "./Truckercap_1_side.vue?vue&type=template&id=12fe5703"
import script from "./Truckercap_1_side.vue?vue&type=script&lang=js"
export * from "./Truckercap_1_side.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__